(function() {
  'use strict';

  angular
    .module('app.pages.result', [])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('result', {
        url: '/result',
        templateUrl: 'app/pages/result/result.html',
        controller: 'ResultController',
        controllerAs: 'vm',
        //Default Params
        params: {
          gender: null,
          value: null
        }
      });

  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.result')
    .controller('ResultController', ResultController);

  /** @ngInject */
  function ResultController($stateParams, $state) {
    var vm = this;

    //Preventing the manual navigation to result page
    if(!$stateParams.value || !$stateParams.gender)
      $state.go('home');

    vm.value = $stateParams.value;
    
    
    //Based on the gender value
    if($stateParams.gender == 'boy'){
      vm.resultLead = "BOY.WORTH"
    }else{
      vm.resultLead = "GIRL.WORTH"
    }


  }

})();

(function() {
  'use strict';

  angular
    .module('socialSweets', [
      'ngAnimate',
      'ngCookies',
      'ngTouch',
      'ngSanitize',
      'ngMessages',
      'ngAria',
      'ui.router',
      'pascalprecht.translate',
      'app.pages.boyFriend',
      'app.pages.girlFriend',
      'app.pages.result'
    ]);

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .controller('GirlFriendController', GirlFriendController);

  /** @ngInject */
  function GirlFriendController($rootScope, $state) {
    var vm = this;

    //Setting the Title and HeaderTitle
    $rootScope.title = "GIRL.TITLE";
    $rootScope.headerTitle = "GIRL.LEAD";

    //Methods Declaration
    vm.showResult = showResult;


    //Initial State
    vm.age = 18;
    vm.height = 150;
    vm.hairColorValue = 5;
    vm.hairLengthValue = 5;
    vm.eyeColourValue = 5;
    vm.boobSizeValue = 5;
    vm.bodyValue = 5;


    //Function to calculate the result and navigate to results page with params
    function showResult() {

      //Simple formula to calculate the number of camels
      vm.total = Math.floor(vm.age/7) + Math.floor(vm.height/10) + vm.hairColorValue + vm.hairLengthValue + vm.eyeColourValue + vm.boobSizeValue + vm.bodyValue;

      //Routing to Results page with the necessary params
      $state.go('result', {gender: 'girl', value: vm.total});

    }

    vm.hairColorOptions = [
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BLONDE',
        value: 5
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BROWN',
        value: 10
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.RED',
        value: 15
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BLACK',
        value: 20
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.GREY',
        value: 25
      }
    ];

    vm.hairLengthOptions = [{
      imageUrl:'assets/images/woman-long-hair.png',
      value:5,
      id:'long'
    },{
      imageUrl:'assets/images/woman-middle-hair.png',
      value: 10,
      id:'middle'
    },{
      imageUrl:'assets/images/woman-short-hair.png',
      value: 15,
      id:'short'
    }];

    vm.eyeColorOptions = [{
      name:'COMMON.EYE_COLOR_OPTIONS.BLUE',
      value: 5
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.GREEN',
      value: 10
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.BROWN',
      value: 15
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.GREY',
      value: 20
    }];

    vm.boobSizeOptions = [{
      imageUrl:'assets/images/boobs-a.png',
      value:5,
      id:'a'
    },{
      imageUrl:'assets/images/boobs-b.png',
      value: 10,
      id:'b'
    },{
      imageUrl:'assets/images/boobs-c.png',
      value: 15,
      id:'c'
    },{
      imageUrl:'assets/images/boobs-d.png',
      value: 20,
      id:'d'
    }];

    vm.bodyOptions = [{
      name:'COMMON.BODY_OPTIONS.THIN',
      value: 5,
      id:'thin'
    },{
      name:'COMMON.BODY_OPTIONS.SPORTY',
      value: 10,
      id:'sporty'
    },{
      name:'COMMON.BODY_OPTIONS.NORMAL',
      value: 15,
      id:'normal'
    },{
      name:'COMMON.BODY_OPTIONS.CHUBBY',
      value: 20,
      id:'chubby'
    },{
      name:'COMMON.BODY_OPTIONS.FAT',
      value: 25,
      id:'fat'
    }];


  }
})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .controller('BoyFriendController', BoyFriendController);

  /** @ngInject */
  function BoyFriendController($rootScope, $state) {
    var vm = this;

    //Setting the Title and HeaderTitle
    $rootScope.title = "BOY.TITLE";
    $rootScope.headerTitle = "BOY.LEAD";

    //Methods Declaration
    vm.showResult = showResult;

    //Initial State
    vm.age = 22;
    vm.height = 160;
    vm.hairColorValue = 5;
    vm.hairLengthValue = 10;
    vm.eyeColourValue = 5;
    vm.beardValue = 10;
    vm.bodyValue = 5;

    //Function to calculate the result and navigate to results page with params
    function showResult() {

      //Simple formula to calculate the number of camels
      vm.total = Math.floor(vm.age/7) + Math.floor(vm.height/10) + vm.hairColorValue + vm.hairLengthValue + vm.eyeColourValue + vm.beardValue + vm.bodyValue;

      //Routing to Results page with the necessary params
      $state.go('result', {gender: 'boy', value: vm.total});

    }


    vm.hairColorOptions = [
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BLONDE',
        value: 5
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BROWN',
        value: 10
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.RED',
        value: 15
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.BLACK',
        value: 20
      },
      {
        name: 'COMMON.HAIR_COLOR_OPTIONS.GREY',
        value: 25
      }
    ];

    vm.hairLengthOptions = [{
      name:'COMMON.HAIR_LENGTH_OPTIONS.LONG',
      value: 5,
      id:'long'
    },{
      name:'COMMON.HAIR_LENGTH_OPTIONS.MIDDLE',
      value: 10,
      id:'middle'
    },{
      name:'COMMON.HAIR_LENGTH_OPTIONS.SHORT',
      value: 20,
      id:'short'
    },{
      name:'COMMON.HAIR_LENGTH_OPTIONS.BALD',
      value: 30,
      id:'bald'
    }];

    vm.eyeColorOptions = [{
      name:'COMMON.EYE_COLOR_OPTIONS.BLUE',
      value: 5
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.GREEN',
      value: 10
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.BROWN',
      value: 15
    }, {
      name:'COMMON.EYE_COLOR_OPTIONS.GREY',
      value: 20
    }];

    vm.beardOptions = [{
      imageUrl:'assets/images/beard-none.png',
      value: 5,
      id:'none'
    },{
      imageUrl:'assets/images/beard-small.png',
      value: 10,
      id:'small'
    },{
      imageUrl:'assets/images/beard-middle.png',
      value: 20,
      id:'middle'
    },{
      imageUrl:'assets/images/beard-full.png',
      value: 30,
      id:'full'
    }];

    vm.bodyOptions = [{
      imageUrl:'assets/images/body-1.png',
      value: 5,
      id:'none'
    },{
      imageUrl:'assets/images/body-2.png',
      value: 10,
      id:'small'
    },{
      imageUrl:'assets/images/body-3.png',
      value: 15,
      id:'middle'
    }];

  }
})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .directive('optionsList', optionsList);

  /** @ngInject */
  function optionsList() {
    var directive = {
      restrict: 'E',
      scope: {
        list: '=',
        title: '@',
        value: '='
      },
      templateUrl: 'app/components/optionsList/optionsList.html',
      controller: OptionsListController,
      controllerAs: 'vm'
    };

    return directive;


    /** @ngInject */
    function OptionsListController($scope) {

      if($scope.title)
        $scope.name = $scope.title;

    }


  }

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .directive('langBar', langBar);

  /** @ngInject */
  function langBar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/langBar/langBar.html',
      controller: LangBarController,
      controllerAs: 'vm'
    };

    return directive;

    /** @ngInject */
    function LangBarController($translate) {
      var vm = this;
      
      //Using $translate service to switch between languages.
      vm.changeLanguage = function (langKey) {
        $translate.use(langKey);
      };

    }
  }

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .directive('camelCounter', camelCounter);

  /** @ngInject */
  function camelCounter() {
    var directive = {
      restrict: 'E',
      scope: {
        number: '@'
      },
      template: '<div class="counter">{{vm.counter}}</div>',
      controller: CamelCounterController,
      controllerAs: 'vm'
    };

    return directive;


    /** @ngInject */
    function CamelCounterController($timeout, $scope) {
      var vm = this;

      //Timefactor to make the animation faster for higher numbers and slower for lower numbers
      var timerFactor = Math.floor(100/$scope.number) * 40;

      for(var i = 0; i <= $scope.number; i++){

        //Using the amazing closure property to nail this effect.
        (function(value) {
          $timeout(function() { vm.counter = value; }, i * timerFactor);
        })(i);

      }

    }


  }

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($rootScope) {

    //Setting the Title and HeaderTitle
    $rootScope.title = "COMMON.WELCOME";
    $rootScope.headerTitle = "COMMON.WELCOME";

  }
})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    
    $stateProvider
      .state('home', {
        url: '/',
        templateUrl: 'app/main/main.html',
        controller: 'MainController',
        controllerAs: 'main'
      });
    
    //Default Router will be the root(home) page.
    $urlRouterProvider.otherwise('/');
  }

})();


(function() {
  'use strict';

  angular
    .module('socialSweets')

})();

(function() {
  'use strict';

  angular
    .module('socialSweets')
    .config(config);

  /** @ngInject */
  function config($logProvider, $locationProvider, $translateProvider) {
    // Enable log
    $logProvider.debugEnabled(true);

    //Enable HTML5 Url
    $locationProvider.html5Mode(true);

    //TRANSLATIONS FOR ENGLISH
    var translationsEN = {
      "COMMON": {
        "WELCOME": "Welcome to Camel Calculator",
        "INTRO": "Here you can calculate how many camels your girlfriend or boyfriend is worth. But first we need some information about the person.",
        "AGE": "Age",
        "HEIGHT": "Height",
        "HAIR_COLOR": "Hair Color",
        "HAIR_COLOR_OPTIONS":{
          "BLONDE": "Blonde",
          "BROWN": "Brown",
          "RED": "Red",
          "BLACK": "Black",
          "GREY": "Grey"
        },
        "HAIR_LENGTH": "Hair Length",
        "HAIR_LENGTH_OPTIONS":{
          "LONG":"Long",
          "MIDDLE":"Middle",
          "SHORT":"Short",
          "BALD":"Bald"
        },
        "EYE_COLOR": "Eye Color",
        "EYE_COLOR_OPTIONS":{
          "BLUE":"Blue",
          "GREEN":"Green",
          "BROWN":"Brown",
          "GREY":"Grey"
        },
        "BODY": "Body",
        "BODY_OPTIONS": {
          "THIN":"Thin",
          "SPORTY":"Sporty",
          "CHUBBY":"Chubby",
          "NORMAL":"Normal",
          "FAT":"Fat"
        },
        "CALCULATE": "Calculate",
        "CALCULATE_AGAIN": "Calculate Again",
        "CAMELS": "Camels",
        "SOCIAL": {
          "FACEBOOK": "POST ON FACEBOOK",
          "TWITTER" : "POST ON TWITTER",
          "WHATSAPP": "SEND ON WHATSAPP"
        }
      },
      "BOY": {
        "TITLE": "Boyfriend Camel Calculator",
        "BEARD": "Beard",
        "LEAD": "How many camels for your boyfriend?",
        "WORTH": "Your boy friend is worth"
      },
      "GIRL": {
        "TITLE": "Girlfriend Camel Calculator",
        "BOOB_SIZE": "Boob Size",
        "FIGURE": "Figure",
        "LEAD": "How many camels for your girlfriend?",
        "WORTH":"Your girl friend is worth"
      }
    };

    //TRANSLATIONS FOR GERMAN
    var translationsDE = {
      "COMMON": {
        "WELCOME": "Kamelrechner",
        "INTRO": "Hier kannst du den Wert deiner Freundin, deines Freundes oder natürlich von dir selbst, in Kamelen berechnen. Hierzu benötigen wir aber erst ein paar Angaben zur Person.",
        "AGE": "Alter",
        "HEIGHT": "Größe",
        "HAIR_COLOR": "Haarfarbe",
        "HAIR_COLOR_OPTIONS":{
          "BLONDE": "Blond",
          "BROWN": "Braun",
          "RED": "Rot",
          "BLACK": "Schwarz",
          "GREY": "Grau"
        },
        "HAIR_LENGTH": "Haarlänge",
        "HAIR_LENGTH_OPTIONS":{
          "LONG":"Lang",
          "MIDDLE":"Mittle",
          "SHORT":"Kurz",
          "BALD":"Glatze"
        },
        "EYE_COLOR": "Augenfarbe",
        "EYE_COLOR_OPTIONS":{
          "BLUE":"Blau",
          "GREEN":"Grun",
          "BROWN":"Braun",
          "GREY":"Grau"
        },
        "BODY": "Oberkörper",
        "BODY_OPTIONS": {
          "THIN":"Mager",
          "SPORTY":"Sportlich",
          "CHUBBY":"Molling",
          "NORMAL":"Normal",
          "FAT":"Dick"
        },
        "CALCULATE": "BERECHNEN",
        "CALCULATE_AGAIN": "NOCHMAL BERECHNEN",
        "CAMELS": "Kamele",
        "SOCIAL": {
          "FACEBOOK": "Auf FACEBOOK Posten",
          "TWITTER" : "Auf TWITTER Posten",
          "WHATSAPP": "Mit WHATSAPP Teilen"
        }
      },
      "BOY": {
        "TITLE": "Freund Kamelrechner",
        "BEARD": "Bart",
        "LEAD": "Wie viele Kamele ist dein Freund wert?",
        "WORTH": "Dein Freund ist wert"
      },
      "GIRL": {
        "TITLE": "Freundin Kamelrechner",
        "BOOB_SIZE": "Körbchengröße",
        "FIGURE": "Figur",
        "LEAD": "Wie viele Kamele ist deine Freundin wert?",
        "WORTH":"Ihre Freundin ist es wert"
      }
    };

    //TRANSLATIONS FOR SPANISH
    var translationsES = {
      "COMMON": {
        "WELCOME": "Calculadora de camellos",
        "INTRO": "Aquí puedes calcular el valor en camellos de tu pareja. Pero primero necesitamos algo de informacion sobre esa persona.",
        "AGE": "Edad",
        "HEIGHT": "Altura",
        "HAIR_COLOR": "Color del pelo",
        "HAIR_COLOR_OPTIONS":{
          "BLONDE": "Rubio",
          "BROWN": "Marron",
          "RED": "Negro",
          "BLACK": "Rojo",
          "GREY": "Gris"
        },
        "HAIR_LENGTH": "Longitud del pelo",
        "HAIR_LENGTH_OPTIONS":{
          "LONG":"Largo",
          "MIDDLE":"Medio",
          "SHORT":"Corto",
          "BALD":"Sin Pelo"
        },
        "EYE_COLOR": "Color de ojos",
        "EYE_COLOR_OPTIONS":{
          "BLUE":"Azul",
          "GREEN":"Verde",
          "BROWN":"Marrón",
          "GREY":"Gris"
        },
        "BODY": "Cuerpo",
        "BODY_OPTIONS": {
          "THIN":"Flaca",
          "SPORTY":"Deportista",
          "CHUBBY":"Regortita",
          "NORMAL":"Normal",
          "FAT":"Gorda"
        },
        "CALCULATE": "Calcular",
        "CALCULATE_AGAIN": "¿Calcular otra vez?",
        "CAMELS": "camellos",
        "SOCIAL": {
          "FACEBOOK": "Publicar en FACEBOOK",
          "TWITTER" : "Publicar en TWITTER",
          "WHATSAPP": "Publicar en WHATSAPP"
        }
      },
      "BOY": {
        "TITLE": "Freund Kamelrechner",
        "BEARD": "Barba",
        "LEAD": "¿Cuántos camellos valdría tu novio?",
        "WORTH": "Dein Freund ist wert"
      },
      "GIRL": {
        "TITLE": "Freundin Kamelrechner",
        "BOOB_SIZE": "Tamaño de los pechos",
        "FIGURE": "Figura",
        "LEAD": "¿Cuántos camellos valdría tu novia?",
        "WORTH":"Ihre Freundin ist es wert"
      }
    };


    //Angular-translate config options.
    $translateProvider.translations('en', translationsEN);
    $translateProvider.translations('de', translationsDE);
    $translateProvider.translations('es', translationsES);

    //Angular-translate setting English as a default language
    $translateProvider.preferredLanguage('en');

    //Angular-translate setting to mitigate XSS related vulnerability
    $translateProvider.useSanitizeValueStrategy('escape');

  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.girlFriend', [])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('girl-friend', {
        url: '/girl-friend',
        templateUrl: 'app/pages/girlfriend/girlfriend.html',
        controller: 'GirlFriendController',
        controllerAs: 'vm'
      });

  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.boyFriend', [])
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider) {

    $stateProvider
      .state('boy-friend', {
        url: '/boy-friend',
        templateUrl: 'app/pages/boyfriend/boyfriend.html',
        controller: 'BoyFriendController',
        controllerAs: 'vm'
      });


  }

})();

angular.module("socialSweets").run(["$templateCache", function($templateCache) {$templateCache.put("app/main/main.html","<div class=container><div class=\"row text-center\"><h2 translate=COMMON.WELCOME></h2><p class=lead translate=COMMON.INTRO></p></div><div class=row><!--Girl Friend--><div class=\"col-md-6 gender-box text-center\"><a ui-sref=girl-friend class=\"list-group-item clearfix\"><img src=assets/images/select-woman.png width=200> </a><span translate=GIRL.LEAD>How many camels for your girlfriend?</span></div><!--Girl Friend--><!--Boy Friend--><div class=\"col-md-6 gender-box text-center\"><a ui-sref=boy-friend class=\"list-group-item clearfix\"><img src=assets/images/select-man.png width=200> </a><span translate=BOY.LEAD>How many camels for your boyfriend?</span></div><!--Boy Friend--></div></div>");
$templateCache.put("app/components/langBar/langBar.html","<div class=pull-right><img src=assets/images/flag-de.png title=German ng-click=\"vm.changeLanguage(\'de\')\" class=lang-opt width=32> <img src=assets/images/flag-en.png title=English ng-click=\"vm.changeLanguage(\'en\')\" class=lang-opt width=32> <img src=assets/images/flag-es.png title=Spanish ng-click=\"vm.changeLanguage(\'es\')\" class=lang-opt width=32></div>");
$templateCache.put("app/components/optionsList/optionsList.html","<div class=row><!--Title--><div class=col-sm-4><h4>{{title | translate}}</h4></div><!--Image or Options Box--><div class=col-sm-8><div class=\"form-group box-radio\"><div class=radio-btn ng-repeat=\"option in list\"><input type=radio name=\"{{name | translate}}\" id=\"{{name | translate}}-{{option.id}}\" ng-value=option.value ng-model=value><label for=\"{{name | translate}}-{{option.id}}\" ng-if=!option.imageUrl>{{option.name | translate}}</label><label for=\"{{name | translate}}-{{option.id}}\" ng-if=option.imageUrl><img ng-src={{option.imageUrl}} alt=none></label></div></div></div></div>");
$templateCache.put("app/pages/boyfriend/boyfriend.html","<div class=container><!--Age--><div class=row><div class=col-sm-4><h4>{{\"COMMON.AGE\" | translate}}<span class=range-value>{{vm.age}}</span></h4></div><div class=col-sm-8><input type=range min=10 max=100 step=1 ng-model=vm.age data-orientation=horizontal></div></div><!--/Age--><hr><!--Height--><div class=row><div class=col-sm-4><h4>{{\"COMMON.HEIGHT\" | translate}}<span class=range-value>{{vm.height}}</span></h4></div><div class=col-sm-8><input type=range min=100 max=220 step=1 ng-model=vm.height data-orientation=horizontal></div></div><!--/Height--><hr><!--Haircolor--><div class=row><div class=col-sm-4><h4 translate=COMMON.HAIR_COLOR>Haircolor</h4></div><div class=col-sm-8><div class=form-group><select class=form-control ng-model=vm.hairColorValue ng-options=\"option.value as option.name | translate for option in vm.hairColorOptions track by $index\"></select></div></div></div><!--/Haircolor--><hr><!--Hairlength--><options-list list=vm.hairLengthOptions title=COMMON.HAIR_LENGTH value=vm.hairLengthValue></options-list><!--/Hairlength--><hr><!--Eyecolor--><div class=row><div class=col-sm-4><h4 translate=COMMON.EYE_COLOR>Eyecolor</h4></div><div class=col-sm-8><div class=form-group><label class=radio-inline ng-repeat=\"option in vm.eyeColorOptions\"><input type=radio name=eyecolor ng-model=vm.eyeColourValue ng-value=option.value> {{option.name | translate}}</label></div></div></div><!--/Eyecolor--><hr><!--Beard--><options-list list=vm.beardOptions title=BOY.BEARD value=vm.beardValue></options-list><!--/Beard--><hr><!--Body--><options-list list=vm.bodyOptions title=COMMON.BODY value=vm.bodyValue></options-list><!--/Body--><hr><div class=row><div class=\"col-sm-4 pull-right\"><button ng-click=vm.showResult() type=button class=\"btn btn-lg btn-primary btn-lg\">{{ \'COMMON.CALCULATE\' | translate}}</button></div></div><hr></div>");
$templateCache.put("app/pages/result/result.html","<div class=container><div class=row><!--Result Lead--><div class=col-sm-12><div class=text-center><h1 translate={{vm.resultLead}}></h1><camel-counter number={{vm.value}}></camel-counter><h1>{{ \"COMMON.CAMELS\" | translate}}</h1></div></div><!--Result Lead--></div><hr><!--Social Sharing--><div class=row><!--Result Lead--><div class=col-sm-12><div class=\"text-center col-md-offset-2\"><button class=\"col-xs-12 col-md-3 btn btn-primary social-btn fb-btn\">{{ \"COMMON.SOCIAL.FACEBOOK\" | translate}}</button> <button class=\"col-xs-12 col-md-3 btn btn-primary social-btn twt-btn\">{{ \"COMMON.SOCIAL.TWITTER\" | translate}}</button> <button class=\"col-xs-12 col-md-3 btn btn-primary social-btn whtsap-btn\">{{ \"COMMON.SOCIAL.WHATSAPP\" | translate}}</button></div></div></div><!--Social Sharing--><hr><div class=row><div class=col-sm-12><div class=text-center><button ui-sref=home class=\"btn btn-lg btn-primary\">{{\"COMMON.CALCULATE_AGAIN\" | translate}}</button></div></div></div></div>");
$templateCache.put("app/pages/girlfriend/girlfriend.html","<div class=container><!--Age--><div class=row><div class=col-sm-4><h4>{{\"COMMON.AGE\" | translate}}<span class=range-value>{{vm.age}}</span></h4></div><div class=col-sm-8><input type=range min=10 max=100 step=1 ng-model=vm.age data-orientation=horizontal></div></div><!--/Age--><hr><!--Height--><div class=row><div class=col-sm-4><h4>{{\"COMMON.HEIGHT\" | translate}}<span class=range-value>{{vm.height}}</span></h4></div><div class=col-sm-8><input type=range min=100 max=220 step=1 ng-model=vm.height data-orientation=horizontal></div></div><!--/Height--><hr><!--Haircolor--><div class=row><div class=col-sm-4><h4 translate=COMMON.HAIR_COLOR>Haircolor</h4></div><div class=col-sm-8><div class=form-group><select class=form-control ng-model=vm.hairColorValue ng-options=\"option.value as option.name | translate for option in vm.hairColorOptions track by $index\"></select></div></div></div><!--/Haircolor--><hr><!--Hairlength--><options-list list=vm.hairLengthOptions title=COMMON.HAIR_LENGTH value=vm.hairLengthValue></options-list><!--/Hairlength--><hr><!--Eyecolor--><div class=row><div class=col-sm-4><h4 translate=COMMON.EYE_COLOR>Eyecolor</h4></div><div class=col-sm-8><div class=form-group><label class=radio-inline ng-repeat=\"option in vm.eyeColorOptions\"><input type=radio name=eyecolor ng-model=vm.eyeColourValue ng-value=option.value> {{option.name | translate}}</label></div></div></div><!--/Eyecolor--><hr><!--Beard--><options-list list=vm.boobSizeOptions title=GIRL.BOOB_SIZE value=vm.boobSizeValue></options-list><!--/Beard--><hr><!--Body--><options-list list=vm.bodyOptions title=GIRL.FIGURE value=vm.bodyValue></options-list><!--/Body--><hr><div class=row><div class=\"col-sm-4 pull-right\"><button ng-click=vm.showResult() type=button class=\"btn btn-primary btn-lg\">{{ \'COMMON.CALCULATE\' | translate}}</button></div></div><hr></div>");}]);